import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import Headroom from 'react-headrooms';
import { findByUrlPartial } from '../../util/urls';
import { appContext } from '../../util/decorators';
import pubSub from '../../util/pubSub';
import MobileNav from './MobileNav';
import Overlay from '../Overlay';
import Nav from './Nav';
import FollowButton from '../Page/FollowButton';
import TranslatedLink from '../TranslatedLink';
import SearchForm from './SearchForm';
import NotificationsWrapper from './NotificationsWrapper';
import translatedRoutes from '../../config/translatedRoutes';
import menusConfig from '../../config/menus';
import TickerAdContainer from 'component/Ads/TickerAdContainer';
import BREAKPOINTS from '../../util/breakpoints';
import updateHeaderHeight from 'action/updateHeaderHeight';
import TickerAdContainer2 from 'component/Ads/TickerAdContainer2';
const isActive = (currentPath, linkPath) => _.startsWith(decodeURIComponent(currentPath), linkPath);

const mapStateToProps = state => ({
  windowWidth: state.events.windowSize.width,
  menuLinks: menusConfig[state.country],
  breakpoint: state.events.breakpoint,
  height: state.events.headerHeight,
  country: state.country,
  language: state.language,
});

@connect(mapStateToProps)
@appContext
export default class Navbar extends React.PureComponent {
  static propTypes = {
    menuLinks: React.PropTypes.shape({
      mainMenuLinks: menuLinks,
      secondaryMenuLinks: menuLinks,
    }),
    windowWidth: React.PropTypes.number,
    path: React.PropTypes.string,
    breakpoint: React.PropTypes.number,
    dispatch: React.PropTypes.func.isRequired,
    country: React.PropTypes.string,
    language: React.PropTypes.string,
    height: React.PropTypes.number,
  };

  constructor() {
    super();

    this.state = {
      showMobileNav: false,
      isSearchVisible: false,
    };

    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.onOutsideClick = this.onOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.onOutsideClick);

    this.setHeight();

    this.tickerHeightSubscription = pubSub.subscribe('tickerHeightChanged', this.setHeight.bind(this));

    this.notificationsOffsetSubscription = pubSub.subscribe('notificationsOffsetChanged', () => {
      this.setHeight();
    });
    this.setMenuRowClass();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      this.setHeight();
      this.setMenuRowClass();
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onOutsideClick);
    this.tickerHeightSubscription.remove();
    this.notificationsOffsetSubscription.remove();
  }

  onOutsideClick(ev) {
    const isClickInside = this.refs.wrapperElement.contains(ev.target);
    if (!isClickInside) this.close();
  }

  setHeight() {
    const height = this.refs.navbarWrapper.clientHeight;
    if (this.props.height !== height) {
      this.props.dispatch(updateHeaderHeight(height || 0));
    }
  }

  setMenuRowClass() {
    const { menuLinks, path } = this.props;
    const sublinks = findByUrlPartial(menuLinks.mainMenuLinks, path, item => item.url).sublinks || [];
    const classList = document.body.parentNode.classList;
    if (sublinks && sublinks.length > 0) {
      classList.add('navbar-two-rows');
      classList.remove('navbar-one-row');
    } else {
      classList.add('navbar-one-row');
      classList.remove('navbar-two-rows');
    }
  }

  close() {
    this.setState({ isSearchVisible: false });
  }

  toggleMobileNav() {
    this.setState(state => ({
      showMobileNav: !state.showMobileNav,
    }), () => {
      if (this.state.showMobileNav) {
        document.addEventListener('click', this.toggleMobileNav);
        document.body.style.overflow = 'hidden';
      } else {
        document.removeEventListener('click', this.toggleMobileNav);
        document.body.style.overflow = 'visible';
      }
    });
  }

  toggleSearch() {
    this.setState(state => ({ isSearchVisible: !state.isSearchVisible }));
  }

  renderTicker(breakpoint) {
    const isMobile = breakpoint <= BREAKPOINTS.MD;
    return (<div className="ticker-ad" style={{order: isMobile ? 0 : -1}}>
       <TickerAdContainer2 />
    </div>);
  }

  render() {
    const t = this.context.app.t;

    const {
      windowWidth,
      menuLinks,
      breakpoint,
      path,
      country,
      language,
      height,
    } = this.props;

    const sublinks = findByUrlPartial(menuLinks.mainMenuLinks, path, item => item.url).sublinks || [];
    const logo = require(`../../../assets/viasport-logo-${country}.png`);
	return (
      <Headroom disable={() => this.state.showMobileNav} classes={{ unpinned: 'is-unpinned' }}
        tolerance={{up: 0, down: 10}}>
        <nav className="navbar navbar-default" role="navigation" style={{ height }}>
          <div className={cx('navbar-wrapper', {'is-fixed': !!height})} ref="navbarWrapper">
            <div className="nav-main container-fluid">
              <div className="navbar-header">
                <Link to="/"><img src={logo} alt="Viasport" /></Link>
              </div>

              <Nav
                showMegaDropdown
                path={path}
                windowWidth={windowWidth}
                menuLinks={menuLinks}
                breakpoint={breakpoint}
                isSearchVisible={this.state.isSearchVisible}
              />
              
              <div className="video-link-container hidden-sm-up">

                 <TranslatedLink name="MobileSportsArticleFeedPage" className={cx('navbar-link video-link', { 'is-active': isActive(path, translatedRoutes[country].VideoPageAllSports.url) })}>Formel 1</TranslatedLink>
              </div>
              

              <div className="search" ref="wrapperElement">
                <SearchForm
                  onChange={() => this.toggleSearch()}
                  isSearchVisible={this.state.isSearchVisible}
                />
              </div>

              <div className="hidden-md-up">
                <button type="button" className="nav-mobile-toggler" onClick={this.toggleMobileNav} aria-hidden="true">
                  <i className="icon-hamburger"></i>
                  <span className="structural">{this.context.app.t('Navbar.menu')}</span>
                </button>
                <Overlay visible={this.state.showMobileNav} className={cx({ 'is-hidden': !this.state.showMobileNav })} onClick={this.toggleMobileNav}>
                  <MobileNav ref="mobileNav" visible={this.state.showMobileNav} menuLinks={menuLinks} />
                </Overlay>
              </div>

              {/*<div className="visible-md-up-flex hidden-lg-up follow-buttons">
                <FollowButton name="facebook" label="Facebook" type="small" />
                <FollowButton name="twitter" label="Twitter" type="small" />
              </div>*/}
            </div>
            {this.renderTicker(breakpoint)}
            {
              sublinks && sublinks.length > 0 &&
                <div className="subnav" >
                  <div className="container-fluid">
                    <Nav path={path} windowWidth={windowWidth} menuLinks={{ mainMenuLinks: sublinks }} showOnMobile breakpoint={breakpoint} />
                  </div>
                </div>
            }

            <NotificationsWrapper country={country} language={language} />
          </div>
        </nav>
      </Headroom>
    );
  }
}

const menuLinks = React.PropTypes.arrayOf(React.PropTypes.shape({
  id: React.PropTypes.number,
  url: React.PropTypes.string,
  name: React.PropTypes.string,
}));



// WEBPACK FOOTER //
// ./src/component/Navigation/Navbar_tickeren_prod_30_03_2020.jsx